const actions = {
  SET_STATE: "widgetState/SET_STATE",
  LIST: "widgetState/LIST",
  CREATE: "widgetState/CREATE",
  DETAIL: "widgetState/DETAIL",
  UPDATE: "widgetState/UPDATE",
  DELETE: "widgetState/DELETE",
};

export default actions;
